"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = exports.useDropdown = void 0;
var bootstrap_1 = require("bootstrap");
var react_1 = require("react");
function useDropdown(options) {
    var _a = react_1.useState(), dropdown = _a[0], setDropdown = _a[1];
    var ref = react_1.useRef(null);
    react_1.useEffect(function () {
        if (ref.current) {
            setDropdown(new bootstrap_1.Dropdown(ref.current, options));
        }
    }, [ref, options]);
    return { dropdown: dropdown, ref: ref };
}
exports.useDropdown = useDropdown;
function useModal(options) {
    var _a = react_1.useState(), modal = _a[0], setModal = _a[1];
    var ref = react_1.useRef(null);
    react_1.useEffect(function () {
        if (ref.current) {
            setModal(new bootstrap_1.Modal(ref.current, options));
        }
    }, [ref, options]);
    return { modal: modal, ref: ref };
}
exports.useModal = useModal;
